<template>
  <v-ons-page :class="homepage == true ? 'l-home' : ''">
    <custom-toolbar modifier="white-content">
      {{ title }}
      <v-ons-toolbar-button slot="left" modifier="white-content" id="menu_btn"
        @click="$store.commit('splitter/toggle');"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
          <g id="Groupe_174" data-name="Groupe 174" transform="translate(-288 -22)">
            <path id="Menu" d="M-6160,14V12h10v2Zm0-6V6h16V8Zm0-6V0h16V2Z" transform="translate(6448 23)" :fill="homepage == true ? '#fff' : '#475056'"/>
            <rect id="Rectangle_1446" data-name="Rectangle 1446" width="16" height="16" transform="translate(288 22)" fill="none"/>
          </g>
        </svg>
      </v-ons-toolbar-button>
    </custom-toolbar>

    <v-ons-tabbar position="bottom"
      swipeable
      :modifier="md ? 'autogrow grey-content' : ''"
      :on-swipe="onSwipe"
      :tabs="tabs"
      :index.sync="index"
    >
      <v-ons-tab v-for="(tab, index) in tabs" :key="index" :icon="tab.icon" :label="$t(tab.label)"></v-ons-tab>
    </v-ons-tabbar>
  </v-ons-page>
</template>

<script>
import Home from './pages/Home.vue';
import Card from './pages/Card.vue';
import Contact from './pages/Contact.vue';
import Emergency from './pages/Emergency.vue';

// Just a linear interpolation formula
const lerp = (x0, x1, t) => parseInt((1 - t) * x0 + t * x1, 10);
// RGB colors
const red = [244, 67, 54];
const blue = [30, 136, 229];
const purple = [103, 58, 183];

export default {
  data () {
    return {
      animationOptions: {},
      topPosition: 0,
      homepage: true,
      tabs: [
        {
          label: 'Home',
          icon: this.md ? 'md-home' : 'ion-ios-home',
          page: Home,
        },
        {
          label: 'Carte VIP',
          icon: this.md ? 'fa-star' : 'ion-ios-star',
          page: Card,
        },
        {
          label: 'Contact',
          icon: this.md ? 'md-phone' : 'ion-ios-phone-portrait',
          page: Contact,
        },
        {
          label: 'Urgences',
          icon: this.md ? 'fa-ambulance' : 'ion-ios-help-buoy',
          page: Emergency,
        }
      ]
    };
  },
  methods: {
    onSwipe(index, animationOptions) {
      this.homepage = index == 0.00;
    }
  },
  computed: {
    index: {
      get() {
        return this.$store.state.tabbar.index;
      },
      set(newValue) {
        this.$store.commit('tabbar/set', newValue)
      }
    },
    title() {
      return this.tabs[this.index].title || this.$i18n.t(this.tabs[this.index].label);
    }
  }
};
</script>


// WEBPACK FOOTER //
// AppTabbar.vue?3197ae6a